import { useEffect, useState } from "react";
import {
    DialogContent,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog";
import { getOtherAddressessApi } from "@/clientSideApi/core";
import Line from '@/components/CustomUI/modules/Loaders/Line';
import Details from "../Details";

const ChooseAddress = ({ handleSelectShippingAddress, toggleAddAddress }) => {

    const [ otherAddress, setOtherAddress ] = useState(null);

    useEffect(() => {
        if(!otherAddress){
            const handleGetAddress = async () => {
                const apiResponse = await getOtherAddressessApi();
                if(apiResponse) setOtherAddress(apiResponse);
            }
            handleGetAddress();
        }
    }, [ otherAddress ])


    return (
        <DialogContent
            className="
                w-screen md:w-[50vw] h-[50vh] bg-white
                overflow-y-scroll vertical-scrollbar 
                flex flex-col
        "
        >
            <DialogHeader
                className="sticky top-[-25px] pb-3 pt-2 bg-white sm:text-center text-base md:text-lg lg:text-xl desktop:text-2xl font-black m-0"
            >
                <span>Choose Address</span>
            </DialogHeader>
            {
                !otherAddress ?
                    <DialogTitle className="h-full flex items-center justify-center border border-sky-500">
                        <span className="mr-3">Feching your addresses</span>
                        <Line loading={true} />
                    </DialogTitle> :
                    otherAddress.addresses.map(shippingAddress => (
                        <Details 
                            key={shippingAddress.pk}
                            inModal={true}
                            shipping_address={shippingAddress}
                            handleSelectShippingAddress={handleSelectShippingAddress}
                            toggleAddAddress={toggleAddAddress}
                        />
                    ))
            }
        </DialogContent>
    )
}

export default ChooseAddress